<script setup>
import { ref } from 'vue';
import { __ } from '@/app';

const currentTheme = ref('auto');

function setTheme(mode = 'auto') {    
    const userMode = localStorage.getItem('bs-theme');
    const sysMode = window.matchMedia('(prefers-color-scheme: light)').matches;
    const useSystem = mode === 'system' || (!userMode && mode === 'auto');
    const modeChosen = useSystem ? 'system' : mode === 'dark' || mode === 'light' ? mode : userMode;    

    if (useSystem) {
        localStorage.removeItem('bs-theme');
    } else {
        localStorage.setItem('bs-theme', modeChosen);
    }
    const theme = useSystem ? (sysMode ? 'light' : 'dark') : modeChosen;
    // console.log(useSystem, modeChosen, theme);
    currentTheme.value = modeChosen;
    document.documentElement.setAttribute('data-bs-theme', theme);
    // data-bs-theme="dark"
    //   document.querySelectorAll('.mode-switch .btn').forEach(e => e.classList.remove('text-body'));
    //   document.getElementById(modeChosen).classList.add('text-body');
}

setTheme();

const btnClass = (btnName) => {    
    return {
        'dropdown-item': true,
        'd-flex': true,
        'align-items-center': true,
        'active': btnName == currentTheme.value
    }
};

const activeThemeClass = () => {
    switch (currentTheme.value) {
        case 'light':
            return {bi: true, 'bi-sun-fill': true};
        case 'dark':
            return {bi: true, 'bi-moon-stars-fill': true};
        default:
            return {bi: true, 'bi-circle-half': true};
    }
}
</script>
<template>
    <li class="dropdown nav-item">                        
        <button class="btn btn-link dropdown-toggle d-flex align-items-center" type="button" id="dropdownMenuButtonLight" data-bs-toggle="dropdown" aria-expanded="false">
            <i :class="activeThemeClass()"></i> <span class="p-2 d-sm-block d-lg-none">{{ __('Motyw') }}</span>
        </button>
        <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButtonLight">
            <li>
                <button type="button" :class="btnClass('light')" @click="setTheme('light')">
                <i class="bi me-2 bi-sun-fill"></i> {{ __('Jasna') }} <i v-if="'light' == currentTheme" class="bi bi-check ms-auto"></i>
                </button>
            </li>
            <li>
                <button type="button" :class="btnClass('dark')" @click="setTheme('dark')">
                    <i class="bi me-2 bi-moon-stars-fill"></i> {{ __('Ciemna') }} <i v-if="'dark' == currentTheme" class="bi bi-check ms-auto"></i>
                </button>
            </li>                
            <li>
                <button type="button" :class="btnClass('system')" @click="setTheme('system')">
                    <i class="bi me-2 bi-circle-half"></i> {{ __('Auto') }} <i v-if="'system' == currentTheme" class="bi bi-check ms-auto"></i>
                </button>
            </li>
        </ul>                        
    </li>
</template>
<style scoped>
.btn, .btn.show, .btn:hover {
    background-color: var(--bs-body-bg);
    color: var(--bs-secondary-color); 
}
</style>